import styled from 'styled-components';

export const Wrapper = styled.div``;

export const Text = styled.p`
  text-align: justify;
  padding: ${({ theme }) => theme.spacing.x5};
  font-size: ${({ theme }) => theme.fs.xs};
  line-height: ${({ theme }) => theme.spacing.x4};
  white-space: pre;
`;
export const ffpInput = styled.div`
  width: 100% !important;
  @media (max-width: ${({ theme }) => theme.media.md}) {
    margin-right: 0 !important;
  }
`;

export const ButtonWrapperSend = styled.div`
  width: 100%;
  margin-top: 1rem !important;
`;
